import { defineMessage } from 'react-intl';

const messages = {
    ariaLabels: {
        playoffFormat: {
            body: defineMessage({
                description: 'Label stating that playoff format info section body is currently being viewed',
                defaultMessage: 'Playoff Format Information',
            }),
            header: defineMessage({
                description: 'Label stating that info section body contains playoff format',
                defaultMessage: 'Playoff Format',
            }),
            toggler: {
                collapse: defineMessage({
                    description: 'Label stating that button will collapse playoff format info section body',
                    defaultMessage: 'Collapse Playoff Format Information',
                }),
                expand: defineMessage({
                    description: 'Label stating that button will expand playoff format info section body',
                    defaultMessage: 'Expand Playoff Format Information',
                }),
            },
        },
        tieBreaking: {
            body: defineMessage({
                description: 'Label stating that tie-breaking procedure info section body is currently being viewed',
                defaultMessage: 'Tie-Breaking Procedure Information',
            }),
            header: defineMessage({
                description: 'Label stating that info section body contains tie-breaking procedure',
                defaultMessage: 'Tie-Breaking Procedure',
            }),
            toggler: {
                collapse: defineMessage({
                    description: 'Label stating that button will collapse tie-breaking procedure info section body',
                    defaultMessage: 'Collapse Tie-Breaking Procedure Information',
                }),
                expand: defineMessage({
                    description: 'Label stating that button will expand tie-breaking procedure info section body',
                    defaultMessage: 'Expand Tie-Breaking Procedure Information',
                }),
            },
        },
    },
};

export default messages;
